<template>
    <jb-buttons no-wrap>
        <div v-if="checkUser">
          <jb-button class="buttons" v-if="(this.params.data.is_main === 1 || this.params.data.is_main === true) || (this.params.data.used_final_score_rule === 1 || this.params.data.used_final_score_rule === true) || (this.params.data.is_active === 1 || this.params.data.is_active === true) || (this.params.data.status === 1 || this.params.data.status === true)" color="warning" :icon="mdiCheckCircle" small @click="activate"/>
          <jb-button class="buttons" v-else color="light" :icon="mdiCheckCircleOutline" small @click="activate" />
        </div>
        <div v-else>
          <jb-button class="buttons" v-if="(this.params.data.is_main === 1 || this.params.data.is_main === true) || (this.params.data.used_final_score_rule === 1 || this.params.data.used_final_score_rule === true) || (this.params.data.is_active === 1 || this.params.data.is_active === true) || (this.params.data.status === 1 || this.params.data.status === true)" color="warning" :icon="mdiCheckCircle" small />
          <jb-button class="buttons" v-else color="light" :icon="mdiCheckCircleOutline" small  />
        </div>
    </jb-buttons>
</template>
<script>
import JbButtons from '@/components/JbButtons'
import JbButton from '@/components/JbButton'
import {
  onBeforeMount,
  ref
} from '@vue/runtime-core'
import { mdiCheckCircle, mdiCheckCircleOutline } from '@mdi/js'
import CryptoJS from 'crypto-js'

export default {
  name: 'ButtonActive',
  components: {
    JbButtons,
    JbButton
  },
  setup (props) {
    const userRole = localStorage.getItem('roles')
    const checkUser = ref(false)
    const userCheck = async () => {
      if (userRole !== null) {
        const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
        const myArray = decryptedMessage.split(',')
        for (let i = 0; i < myArray.length; i++) {
          if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_HRD' || myArray[i] === 'ROLE_ADMIN_FINANCE') {
            checkUser.value = true
          }
        }
      }
    }
    onBeforeMount(() => {
        userCheck()
    })
    return {
      userRole,
      userCheck,
      checkUser,
      mdiCheckCircle,
      mdiCheckCircleOutline
    }
  },
  methods: {
    activate (event) {
      // the grid component can now be accessed via this.params.context.componentParent
      this.params.context.componentParent.activate(event, this.params.data)
    }
  }

}
</script>
